import { render } from "./HelloWorld.vue?vue&type=template&id=ac4d7fe4&scoped=true&ts=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=ac4d7fe4&scoped=true&lang=scss"

import exportComponent from "/Users/jqrgen/dev/oida/webclient/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac4d7fe4"]])

export default __exports__